import './infographic.less'

import {Image} from '@codeurs/front'
import React from 'react'
import {ImageType} from 'types'
import {style} from 'util/style'
import {Column, Grid} from 'views/layout/grid'
import {Theme} from 'views/theme'

const styles = style('infographic', ['item'])

export type InfographicType = {
	number_left?: ImageType
	number_center?: ImageType
	number_right?: ImageType
	description_left?: string
	description_center?: string
	description_right?: string
}

export type InfographicItemType = {
	number: any
	description?: string
}

export const Infographic: React.FC<InfographicType> = ({
	number_left,
	number_center,
	number_right,
	description_left,
	description_center,
	description_right
}) => {
	return (
		<div className={styles()}>
			<Theme.OuterContainer>
				<Theme.Container>
					<Grid columns={1} m={2} l={3} xl={3} xxl={3}>
						<Column>
							<InfographicItem
								number={number_left}
								description={description_left}
							/>
						</Column>
						<Column>
							<InfographicItem
								number={number_center}
								description={description_center}
							/>
						</Column>
						<Column>
							<InfographicItem
								number={number_right}
								description={description_right}
							/>
						</Column>
					</Grid>
				</Theme.Container>
			</Theme.OuterContainer>
		</div>
	)
}

export const InfographicItem: React.FC<InfographicItemType> = ({
	number,
	description
}) => (
	<div className={styles.item()}>
		<div className={styles.item('number')}>
			<div className={styles.item('number-digit')}>
				{number && (
					<Image
						src={'/admin/' + number.path}
						alt={number.alt || number.description || 'Infographic number'}
					/>
				)}
			</div>
		</div>
		<div className={styles.item('description')}>
			<Theme.Wysiwyg>{description}</Theme.Wysiwyg>
		</div>
	</div>
)
